
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 9 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.093 13.472a.304.304 0 000 .437.324.324 0 00.45 0l6.364-6.19a.304.304 0 000-.438l-6.364-6.19a.325.325 0 00-.45 0 .304.304 0 000 .437l6.142 5.975-6.142 5.969z","fill":"#FFF","stroke":"#979797"}})])
          )
        }
      }
    